import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useState, useEffect } from 'react';
import Icon from '../../Atoms/Icon';
import Title from '../../Atoms/Title';
import Clipboard from '../../Molecules/Clipboard';
import FormMail from '../../Molecules/FormMail';
import Button from '../../Atoms/Button';

interface Props {
  modalOpen: boolean;
  modalHandler: (openState: boolean) => void;
}

function ModalShareJob({ modalOpen, modalHandler }: Props) {
  const [isOpen, setIsOpen] = useState<boolean>(modalOpen);

  useEffect(() => {
    setIsOpen(modalOpen);
  }, [modalOpen]);

  return (
    <Transition show={isOpen}>
      <Dialog onClose={() => modalHandler(false)}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 z-[100] bg-sl-blue-dark bg-opacity-75 text-opacity-50" />
        </Transition.Child>
        <div className="fixed inset-0 z-[150] overflow-y-auto">
          <div className="flex min-h-full justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 -translate-y-10"
              enterTo="opacity-100 translate-y-0"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 -translate-y-10"
            >
              <Dialog.Panel className="relative w-full max-w-2xl py-10">
                <button
                  className="absolute top-0 right-0 flex h-10 w-10 items-center justify-center rounded-full bg-white text-base text-sl-blue"
                  type="button"
                  onClick={() => modalHandler(false)}
                  aria-label="close modal"
                >
                  <Icon icon="x-mark" />
                </button>
                <div className="pt-14">
                  <div className="w-full overflow-hidden rounded-xl bg-white">
                    <div className="py-8 px-5 md:px-10">
                      <Title
                        as="h3"
                        size={5}
                        color="blue-dark"
                      >
                        Bewaar deze vacature
                      </Title>

                      <div className="border-b-2 border-sl-blue border-opacity-10 pt-7 pb-9">
                        <Title
                          as="h4"
                          size={6}
                          font="camphor"
                          weight={500}
                          color="blue"
                          className="mb-3"
                        >
                          Mail deze vacature naar jezelf
                        </Title>
                        <FormMail />
                      </div>

                      <div className="border-b-2 border-sl-blue border-opacity-10 pt-7 pb-9">
                        <Title
                          as="h4"
                          size={6}
                          font="camphor"
                          weight={500}
                          color="blue"
                          className="mb-3"
                        >
                          Kopieer de ondestraande link
                        </Title>
                        <Clipboard value="https://lorem.net" />
                      </div>
                      <div className="flex flex-col items-center justify-between gap-7 pt-8 text-center md:flex-row md:text-left">
                        <Title
                          as="h4"
                          size={6}
                          font="camphor"
                          weight={600}
                        >
                          Deel via Social Media
                        </Title>
                        <div className="flex gap-3.5">
                          <Button
                            iconName="whatsapp"
                            fullRounded
                            shadow
                            color="green-wa"
                            size="lg"
                          />
                          <Button
                            iconName="facebook"
                            fullRounded
                            shadow
                            color="blue-fb"
                            size="lg"
                          />
                          <Button
                            iconName="linkedin"
                            fullRounded
                            shadow
                            color="blue-in"
                            size="lg"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

export default ModalShareJob;
